import React, { useEffect } from "react";
import UrlTag from "../components/UrlTag";
import { Link } from "react-router-dom";
import { FaArrowRight } from "react-icons/fa";

import ExpertiseImg from '../Images/Expertise.jpg';
import Architecture from '../Images/Architecture.jpg';
import ClimateAndSustainableDesign from '../Images/climateAndSustainableDesign.jpg';
import Engineering from "../Images/Engineering.jpg";
import IndustrialDesign from "../Images/IndustrialDesign.jpg";
import Interiors from "../Images/Interiors.jpg";
import Technology from "../Images/Technology.jpg";
import UrbanLandscape from "../Images/UrbanLandscape.jpg";
import WorkplaceConsultancy from "../Images/WorkplaceConsultancy.jpg";

const items = [
    {
        title: "Architecture",
        imgSrc: Architecture,
        imgAlt: "Architecture",
        linkSrc: "architecture"
    },
    {
        title: "Climate and Sustainable Design",
        imgSrc: ClimateAndSustainableDesign,
        imgAlt: "Climate and Sustainable Design",
        linkSrc: "climate-and-sustainable-design"
    },
    {
        title: "Engineering",
        imgSrc: Engineering,
        imgAlt: "Engineering",
        linkSrc: "engineering"
    },
    {
        title: "Industrial Design",
        imgSrc: IndustrialDesign,
        imgAlt: "Industrial Design",
        linkSrc: "industrial-design"
    },
    {
        title: "Interiors",
        imgSrc: Interiors,
        imgAlt: "Interiors",
        linkSrc: "interiors"
    },
    {
        title: "Urban and Landscape Design",
        imgSrc: UrbanLandscape,
        imgAlt: "Urban and Landscape Design",
        linkSrc: "urban-and-landscape-design"
    },
    {
        title: "Workplace Consultancy",
        imgSrc: WorkplaceConsultancy,
        imgAlt: "Workplace Consultancy",
        linkSrc: "workplace-consultancy"
    }
];

const Expertise = () => {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <div className="z-20">
            <UrlTag />
            <div className="relative">
                <img src={ExpertiseImg} alt="Expertise" className="w-full h-[300px] md:h-[500px] object-cover" />
                <div className="absolute inset-0 bg-black opacity-40"></div>
                <div className="absolute bottom-0 left-0 py-4 md:py-8 px-4 md:px-14">
                    <h1 className="text-white text-2xl md:text-4xl font-bold">Expertise</h1>
                </div>
            </div>
            <div className="mt-8 md:mt-16 max-w-[900px] md:mx-auto mx-4  mb-10">
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                    {items.map((item, index) => (
                        <Link to={`/expertise/${item.linkSrc}`} key={index}>
                            <div className="bg-[#f5f5f5] rounded-lg overflow-hidden shadow-md hover:shadow-sm transition-shadow duration-300">
                                <img src={item.imgSrc} alt={item.imgAlt} className="w-full h-56 object-cover transition-transform duration-500 ease-in-out hover:scale-105" />
                                <div className="px-4 py-6 flex justify-between items-center">
                                    <h2 className="text-xl md:text-2xl text-gray-700">{item.title}</h2>
                                    <button className="text-gray-500 p-2 bg-white rounded-full">
                                        <FaArrowRight />
                                    </button>
                                </div>
                            </div>
                        </Link>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default Expertise;